(() => {
  angular
    .module('gm.common.user')
    .directive('gmySignInForm', gmySignInForm);

  function gmySignInForm(
    btgUser,
    Gmy2FA,
    GmyFeatures
  ) {
    'ngInject';

    const ERROR_SMS = 'error.during.sending.sms';
    const ERROR_VERIFICATION = 'error.during.verification';
    const INVALID_CREDENTIALS = 'invalid.credentials';
    const INVALID_AUTH_TOKEN = 'missing.auth.token';
    const MISSING_CAPTCHA = 'missing.captcha';
    const ROUTE_PARAM_EMAIL_EXPIRED = 'email-expired';
    const ROUTE_PARAM_EMAIL_VERIFIED = 'email-verified';
    const ROUTE_PARAM_PASSWORD_RESET = 'reset';
    const ROUTE_PARAM_SIGNEDOUT = 'logout';
    const ROUTE_PARAM_PROGRESS_SAVED = 'progress-saved';
    const ROUTE_PARAM_SUSPENDED = 'suspended';

    return {
      link,
      restrict: 'E',
      scope: {
        isErrorDisplayed: '=?',
        isFormValid: '=?',
        message: '=?',
        onError: '&?',
        onSuccess: '&?',
        onSignIn: '&?',
        showCta: '=?',
        showOptions: '=?',
        triggerSignIn: '=?',
      },
      templateUrl: 'modules/user/directives/sign-in-form/sign-in-form.html',
    };

    function link(scope, _element, attrs) {
      scope.captcha = {};
      scope.class = (attrs.class) ? attrs.class : '';
      scope.isErrorDisplayed = false;
      scope.isFormValid = false;
      scope.signInData = {};
      scope.showCta = (!angular.isUndefined(scope.showCta)) ? scope.showCta : true;
      scope.showOptions = (!angular.isUndefined(scope.showOptions)) ? scope.showOptions : true;

      GmyFeatures.checkFeatureEnabled('signup')
        .then((enabled) => {
          scope.signupEnabled = enabled;
        });

      switch (scope.message) {
        case ROUTE_PARAM_EMAIL_EXPIRED:
          scope.emailExpired = true;
          break;
        case ROUTE_PARAM_EMAIL_VERIFIED:
          scope.emailVerified = true;
          break;
        case ROUTE_PARAM_PASSWORD_RESET:
          scope.passwordReset = true;
          break;
        case ROUTE_PARAM_SIGNEDOUT:
          scope.signedOut = true;
          break;
        case ROUTE_PARAM_SUSPENDED:
          scope.suspended = true;
          break;
        case INVALID_CREDENTIALS:
        case MISSING_CAPTCHA:
          scope.invalidCredentials = true;
          break;
        case ERROR_SMS:
          scope.invalidSms = true;
          break;
        case ERROR_VERIFICATION:
          scope.invalidVerification = true;
          break;
        case ROUTE_PARAM_PROGRESS_SAVED:
          scope.signupProgressSaved = true;
          break;
        default:
          break;
      }

      function resetError() {
        ['suspended', 'unknown', 'wrong', 'twoFactAuth']
          .map(error => scope.formSignIn.$setValidity(error, true));
        scope.isErrorDisplayed = false;
      }

      function showError(error) {
        if (scope.onError) {
          scope.onError();
        }

        if (('data' in error) && (error.data !== null)
          && ('message' in error.data) && (error.data.message.length > 0)) {
          scope.emailExpired = false;
          scope.emailVerified = false;
          scope.passwordReset = false;
          scope.signedOut = false;
          scope.suspended = false;
          scope.invalidCredentials = false;
          scope.invalidVerification = false;
          scope.isErrorDisplayed = true;

          if (error.data.message === INVALID_CREDENTIALS) {
            scope.formSignIn.$setValidity('wrong', false);
            if (scope.captchaNeeded) {
              scope.$broadcast('gm:captcha:reset');
            }
          } else if (error.status === 423) {
            scope.formSignIn.$setValidity('suspended', false);
          } else if (error.data.message === ERROR_VERIFICATION) {
            scope.formSignIn.$setValidity('twoFactAuth', false);
          } else if (error.data.message === 'missing.captcha') {
            scope.captchaNeeded = 'true';
            scope.formSignIn.$setValidity('wrong', true);
            scope.formSignIn.$setValidity('captcha', false);
          } else if (error.data.message === 'invalid.captcha') {
            scope.$broadcast('gm:captcha:reset');
          } else if (error.data.message === INVALID_AUTH_TOKEN) {
            scope.invalidToken = true;
          } else if (error.data.message === 'missing.captcha') {
            scope.formSignIn.$setValidity('unknown', false);
          }
        } else {
          scope.formSignIn.$setValidity('unknown', false);
        }
      }

      function signIn() {
        if (scope.onSignIn) {
          scope.onSignIn();
        }

        if ((!scope.formSignIn.email.$error.required) && scope.formSignIn.password.$valid) {
          // Making a copy since the browser can decide to change the autofilled data
          // between the first and second 2fa call:
          const signInData = angular.copy(scope.signInData);
          return Gmy2FA.executeWith2FA(
            twoFactAuth => btgUser.signIn(signInData, twoFactAuth, scope.captcha.code),
            'signIn'
          )
          .then(() => {
            if (scope.onSuccess) {
              scope.onSuccess();
            }
          })
          .catch(showError);
        }
        return false;
      }

      scope.resetError = resetError;
      scope.signIn = signIn;

      scope.$watchGroup([
        'formSignIn.email.$invalid',
        'formSignIn.password.$invalid',
        'formSignIn.recaptcha.$invalid'
      ], (newValues, oldValues) => {
        if (newValues !== oldValues) {
          if ((newValues[0]) || (newValues[1]) || (newValues[2])) {
            scope.isFormValid = false;
          } else {
            scope.isFormValid = true;
            scope.isErrorDisplayed = false;
          }
        }
      });

      scope.$watch('triggerSignIn', (newVal, oldVal) => {
        if ((newVal) && (newVal !== oldVal)) {
          scope.formSignIn.$submitted = true;
          scope.signIn();
        }
      });
    }
  }
})();
